import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ParkingBillingSetting } from '../models/parkingBillingSetting.ts';
import { fetchParkingBillingSetting } from '../api/parking-billing-setting.ts';

export default function useParkingBillingSetting(
  id: string,
): UseQueryResult<ParkingBillingSetting, Error> {
  return useQuery<ParkingBillingSetting>({
    queryKey: ['parkingBillingSettings', id],
    queryFn: () => fetchParkingBillingSetting(id),
    enabled: id !== undefined,
  });
}
